'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _reactRouter = require('react-router');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _constants = require('../../constants');

var _common = require('../common');

var _util = require('../../utils/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var GROUPS = _constants.AppConstants.GROUPS,
    HIJACK_QUERY_PARAMS = _constants.AppConstants.HIJACK_QUERY_PARAMS,
    USER_FLOW = _constants.AppConstants.USER_FLOW;
var BaseApplicationsPage = (_dec = (0, _mobxReact.inject)('ApplicationStore', 'FunderStore', 'SessionStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(BaseApplicationsPage, _Component);

  function BaseApplicationsPage() {
    _classCallCheck(this, BaseApplicationsPage);

    return _possibleConstructorReturn(this, (BaseApplicationsPage.__proto__ || Object.getPrototypeOf(BaseApplicationsPage)).apply(this, arguments));
  }

  _createClass(BaseApplicationsPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          pageStore = _props.pageStore,
          FunderStore = _props.FunderStore,
          setColumns = _props.setColumns,
          _browserHistory$getCu = _reactRouter.browserHistory.getCurrentLocation(),
          query = _browserHistory$getCu.query,
          ordering = query.ordering && (0, _util.unformatSortingParams)(query.ordering),
          filters = (0, _omit3.default)(query, ['ordering'].concat(HIJACK_QUERY_PARAMS));

      pageStore.tableType = (0, _get3.default)(query, 'type', FunderStore.defaultApplicationType);
      setColumns(pageStore.tableType);
      pageStore.ordering = ordering || [];
      pageStore.filters = (0, _isEmpty3.default)(filters) ? this.defaultFilters : filters;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.pageStore.loading = true;
      this.handleFilterChange({ onInitialPageLoad: true });
    }
  }, {
    key: 'changeFilters',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var onQueryReset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.props.pageStore.loading = true;
                _context.next = 3;
                return this.handleFilterChange({ onQueryReset: onQueryReset });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function changeFilters() {
        return _ref.apply(this, arguments);
      }

      return changeFilters;
    }()
  }, {
    key: 'handleFilterChange',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref3$onInitialPageLo = _ref3.onInitialPageLoad,
            onInitialPageLoad = _ref3$onInitialPageLo === undefined ? false : _ref3$onInitialPageLo,
            _ref3$onQueryReset = _ref3.onQueryReset,
            onQueryReset = _ref3$onQueryReset === undefined ? false : _ref3$onQueryReset;

        var _props2, pageStore, pageTitle, fetchData, fetchCounts, queryMap, SessionStore, _browserHistory$getCu2, pathname, query, data, eventName, eventData;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props2 = this.props, pageStore = _props2.pageStore, pageTitle = _props2.pageTitle, fetchData = _props2.fetchData, fetchCounts = _props2.fetchCounts, queryMap = _props2.queryMap, SessionStore = _props2.SessionStore, _browserHistory$getCu2 = _reactRouter.browserHistory.getCurrentLocation(), pathname = _browserHistory$getCu2.pathname;
                query = pageStore.query;

                query.type = pageStore.tableType;

                _reactRouter.browserHistory.push({ pathname: pathname, query: query });

                if (queryMap) {
                  query = queryMap(query);
                }

                // fetch counts asynchronously
                fetchCounts(query, pageStore.tableType).then(function (counts) {
                  pageStore.sidebarCounts = counts;
                });

                _context2.next = 8;
                return fetchData(query, pageStore.tableType);

              case 8:
                data = _context2.sent;

                if (data) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt('return');

              case 11:
                eventName = pageTitle === 'Applications' ? 'APPLICATIONS_QUERY_CHANGE' : 'REJ_APPLICATIONS_QUERY_CHANGE', eventData = _extends({
                  on_initial_page_load: onInitialPageLoad,
                  on_query_reset: onQueryReset
                }, pageStore.queryToLog);

                SessionStore.trackEvent(eventName, eventData);

                pageStore.tableData = data.results;
                pageStore.nextPageURL = data.next;
                pageStore.loading = false;

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleFilterChange() {
        return _ref2.apply(this, arguments);
      }

      return handleFilterChange;
    }()
  }, {
    key: 'changeTableType',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(selection) {
        var pageStore;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                pageStore = this.props.pageStore;

                if (!(pageStore.tableType === selection.type)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt('return');

              case 3:
                pageStore.loading = true;
                pageStore.tableType = selection.type;
                pageStore.filters = this.defaultFilters;
                _context3.next = 8;
                return this.handleFilterChange();

              case 8:
                this.props.setColumns(pageStore.tableType);
                pageStore.loading = false;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function changeTableType(_x3) {
        return _ref4.apply(this, arguments);
      }

      return changeTableType;
    }()
  }, {
    key: 'onLoadMoreClick',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _props3, ApplicationStore, pageStore, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _props3 = this.props, ApplicationStore = _props3.ApplicationStore, pageStore = _props3.pageStore;


                pageStore.loading = true;
                _context4.next = 4;
                return ApplicationStore.loadMore(pageStore.nextPageURL);

              case 4:
                data = _context4.sent;

                pageStore.tableData = pageStore.tableData.concat(data.results);
                pageStore.nextPageURL = data.next;
                pageStore.loading = false;

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onLoadMoreClick() {
        return _ref5.apply(this, arguments);
      }

      return onLoadMoreClick;
    }()
  }, {
    key: 'rowLocation',
    value: function rowLocation(state, rowInfo, column) {
      var case_id = (0, _get3.default)(rowInfo, 'original.case_id');
      return !!case_id && { pathname: '/case/' + case_id + '/details/feed', state: USER_FLOW.FROM_APPLICATIONS_PAGE };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          pageName = _props4.pageName,
          pageStore = _props4.pageStore,
          pageTitle = _props4.pageTitle,
          SidebarComponent = _props4.SidebarComponent,
          tableColumns = _props4.tableColumns,
          tableTitle = _props4.tableTitle;


      return _react2.default.createElement(
        _common.Page,
        { name: pageName, type: 'list', hasSidebar: true },
        _react2.default.createElement(_reactHelmet2.default, { title: pageTitle }),
        _react2.default.createElement(
          _common.Page.Sidebar,
          null,
          _react2.default.createElement(SidebarComponent, {
            changeFilters: this.changeFilters,
            changeTableType: this.changeTableType,
            sidebarCounts: pageStore.sidebarCounts,
            tableType: pageStore.tableType
          })
        ),
        _react2.default.createElement(
          _common.Page.Content,
          null,
          _react2.default.createElement(_common.BaseList, {
            columns: tableColumns,
            entityType: 'applications',
            handleSort: this.changeFilters,
            onLoadMoreClick: this.onLoadMoreClick,
            pageStore: pageStore,
            rowLocation: this.rowLocation,
            title: tableTitle
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'defaultFilters',
    get: function get() {
      var user = this.props.SessionStore.user,
          userIsAdmin = (0, _get3.default)(user, 'groups', false) && user.groups.includes(GROUPS.ADMIN),
          userIsExecutive = (0, _get3.default)(user, 'groups', false) && user.groups.includes(GROUPS.EXECUTIVE);


      return userIsAdmin || userIsExecutive ? {} : { representative: (0, _get3.default)(user, 'id', null) };
    }
  }]);

  return BaseApplicationsPage;
}(_react.Component), _class3.propTypes = {
  ApplicationStore: _propTypes2.default.object.isRequired,
  fetchCounts: _propTypes2.default.func.isRequired,
  fetchData: _propTypes2.default.func.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  pageName: _propTypes2.default.string,
  pageStore: _propTypes2.default.object.isRequired,
  pageTitle: _propTypes2.default.string,
  queryMap: _propTypes2.default.func,
  SessionStore: _propTypes2.default.object.isRequired,
  setColumns: _propTypes2.default.func.isRequired,
  SidebarComponent: _propTypes2.default.func.isRequired,
  tableColumns: _propTypes2.default.array,
  tableTitle: _propTypes2.default.string
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'changeFilters', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'changeFilters'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleFilterChange', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleFilterChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'changeTableType', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'changeTableType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onLoadMoreClick', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onLoadMoreClick'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = BaseApplicationsPage;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(GROUPS, 'GROUPS', '/app/src/components/base/BaseApplicationsPage.js');
  reactHotLoader.register(HIJACK_QUERY_PARAMS, 'HIJACK_QUERY_PARAMS', '/app/src/components/base/BaseApplicationsPage.js');
  reactHotLoader.register(USER_FLOW, 'USER_FLOW', '/app/src/components/base/BaseApplicationsPage.js');
  reactHotLoader.register(BaseApplicationsPage, 'BaseApplicationsPage', '/app/src/components/base/BaseApplicationsPage.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/base/BaseApplicationsPage.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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